/*
 * @Author: wsx
 * @Date: 2022-01-19 09:28:58
 * @LastEditTime: 2022-01-19 17:49:18
 * @LastEditors: your name
 * @Description:
 */
import request from "@/utils/request.js";

/*
 * @Author: gp
 * @Date: 2022-24-24 09:28:58
 * @Description: 人脸对比
 */

// 获取算法名和版本
export const queryinstalled = data => {
  return request({
    url: "/apiData/hz-data-community/zghz/znyy/disposition/algorithm/installed",
    method: "post",
    params: data
  });
};
// 1：1人脸比对
export const queryFileSimilar = data => {
  return request({
    url: "/apiData/hz-data-community/zghz/znyy/file-similar",
    method: "post",
    data: data
  });
};

/*
 * @Author: gp
 * @Date: 2022-24-24 09:28:58
 * @Description: 身份稽查
 */

// 获取名单库列表信息
export const queryRepositoryList = data => {
  return request({
    url: "/apiData/hz-data-community/zghz/znyy/identity/repository-list",
    method: "post",
    data: data
  });
};
// 静态库人脸以图搜图
export const queryIdentityList = data => {
  return request({
    url: "/apiData/hz-data-community/zghz/znyy/search/identity/list",
    method: "post",
    data: data
  });
};
/*
 * @Author: gp
 * @Date: 2022-24-24 09:28:58
 * @Description: 车辆检索
 */

// 车辆检索
export const recordWithTotal = (data, loadingObj) => {
  return request({
    url: "/apiData/hz-data-community/zghz/vehicle-analysis/tollgate/record/with-total",
    method: "post",
    data: data,
    ...loadingObj
  });
};

// 车辆检索
export const carRecord = (data, loadingObj) => {
  return request({
    url: "/apiData/hz-data-community/styp/car_search_detail/car/record",
    method: "post",
    data: data,
    ...loadingObj
  });
};

// 车辆检索
export const carRecordExport = (data) => {
  return request({
    url: "/apiData/hz-data-community/styp/car_search_detail/car/record/export",
    method: "post",
    data: data,
    responseType: "blob"
  });
};

// 车辆检索6.1后接口
export const propRetrievalV2 = (data, loadingObj) => {
  return request({
    url: "/apiData/hz-data-community/zghz/viid/vehicle/prop-retrieval",
    method: "post",
    data: data,
    ...loadingObj
  });
};
/*
 * @Author: gp
 * @Date: 2022-24-24 09:28:58
 * @Description: 视图研判
 */

// 模糊查询任务名称,获取线索摸排任务列表
export const clueTasks = data => {
  return request({
    url: "/apiData/hz-data-community/zghz/view_judge/clue-tasks",
    method: "get",
    params: data
  });
};
// 模糊查询任务名称,获取线索摸排任务列表
export const clueTasksDel = data => {
  return request({
    url: "/apiData/hz-data-community/zghz/view_judge/clue-tasks",
    method: "delete",
    params: data
  });
};

// 获取算力
export const getResources = data => {
  return request({
    url: "/apiData/hz-data-community/zghz/analysis_configuration/aix/resources",
    method: "get",
    params: data
  });
};

// 新建线索摸排任务
export const createClueTask = data => {
  return request({
    url: "/apiData/hz-data-community/zghz/view_judge/clue-task",
    method: "post",
    data: data
  });
};

// 线索摸排结果查询
export const getRetrieval = (data, loadingObj) => {
  return request({
    url: "/apiData/hz-data-community/zghz/view_judge/clue-snap/retrieval",
    method: "post",
    data: data,
    ...loadingObj
  });
};

// 根据id获取线索摸排任务列表
export const getClueTaskID = data => {
  return request({
    url: "/apiData/hz-data-community/zghz/view_judge/get/clue-task",
    method: "get",
    params: data
  });
};

// 线索简介统计
export const getClueSnapTotal = data => {
  return request({
    url: "/apiData/hz-data-community/zghz/view_judge/clue-snap/total",
    method: "post",
    data: data
  });
};

// 地图绘制的数据
export const maparealist = data => {
  return request({
    url: "/api/hz-smart-community/styp/maparea/list",
    params: data
  });
};
// 地图绘制的添加
export const mapareasave = data => {
  return request({
    url: "/api/hz-smart-community/styp/maparea/save",
    data: data,
    method: "post"
  });
};

// 地图绘制的添加
export const mapareaDelete = data => {
  return request({
    url: "/api/hz-smart-community/styp/maparea/delete",
    data: data,
    method: "post"
  });
};
// 图片寻人--人脸抓拍查询
export const getSnapRetrievalFace = (data, loadingObj) => {
  return request({
    url: "/apiData/hz-data-community/zghz/view_judge/snap-retrieval/face",
    method: "post",
    data: data,
    ...loadingObj
  });
};

// 图片寻人--人体抓拍查询
export const getSnapRetrievalPerson = (data, loadingObj) => {
  return request({
    url: "/apiData/hz-data-community/zghz/view_judge/snap-retrieval/person",
    method: "post",
    data: data,
    ...loadingObj
  });
};

// 图片寻人--机动车抓拍查询
export const getSnapRetrievalVehicle = (data, loadingObj) => {
  return request({
    url: "/apiData/hz-data-community/zghz/view_judge/snap-retrieval/vehicle",
    method: "post",
    data: data,
    ...loadingObj
  });
};
// 图片寻人--非机动车抓拍查询
export const getSnapRetrievalNonVehicle = (data, loadingObj) => {
  return request({
    url: "/apiData/hz-data-community/zghz/view_judge/snap-retrieval/non-vehicle",
    method: "post",
    data: data,
    ...loadingObj
  });
};
// 获取布控信息
export const dispositioninfo = data => {
  return request({
    url: "/apiData/hz-data-community/zghz/mg_disposition/info",
    params: data
  });
};

// 离线文件 （视频任务）
export const videoFilesList = data => {
  return request({
    url: "/apiData/hz-data-community/zghz/analysis_configuration/files_list",
    method: "post",
    data: data
  });
};

// 获取所有大任务列表 （文件任务）
export const tasksFilesList = data => {
  return request({
    url: "/apiData/hz-data-community/zghz/analysis_configuration/tasks/all-list-by-type",
    params: data
  });
};

// 获取轨迹列表
export const pathList = data => {
  return request({
    url: "/api/hz-smart-community/styp/path/list",
    params: data
  });
};
// 添加轨迹
export const savePathList = data => {
  return request({
    url: "/api/hz-smart-community/styp/path/save",
    data: data,
    method: "post",
  });
};
// 添加轨迹
export const deletePathList = data => {
  return request({
    url: "/api/hz-smart-community/styp/path/delete",
    data: data,
    method: "post",
  });
};
// 图片截取
export const featureall = data => {
  return request({
    url: "/apiData/hz-data-community/zghz/znyy/vids/feature/all",
    method: "post",
    data: data
  });
};
// 图片截取
export const featureallV2 = data => {
  return request({
    url: "/apiData/hz-data-community/zghz/znyy/vids/feature/all/V2",
    method: "post",
    data: data
  });
};

// 批量获取任务详情
export const batchDetail = data => {
  return request({
    url: "/apiData/hz-data-community/zghz/analysis_configuration/tasks/batch-detail",
    method: "post",
    data: data
  });
};

// 摸排任务资源
export const clueTaskSources = data => {
  return request({
    url: "/apiData/hz-data-community/zghz/view_judge/clue-task/sources",
    method: "post",
    data: data
  });
};